import { TemaReuniaoEnum } from 'graphql/types.generated'

export const isOnlyEducacaoPermanente = (temasReuniao: ReadonlyArray<TemaReuniaoEnum>) =>
  temasReuniao?.length === 1 && temasReuniao.includes(TemaReuniaoEnum.EDUCACAO_PERMANENTE)
